<tui-island class="lp-statistics-card">
  <div *ngIf="selectCard; else unknownTypeTmp" class="tui-island__content">
    <div *ngIf="isDesktop" class="tui-island__figure">
      <button tuiIconButton class="figure" type="button" appearance="flat" [iconStart]="selectCard.icon" size="m"></button>
    </div>

    <div>
      <h3 class="tui-island__title">{{ count }}</h3>
      <p class="tui-island__paragraph">{{ selectCard.title | translate }}</p>
    </div>
  </div>

  <ng-template #unknownTypeTmp>
    {{ 'components.lpStatisticsCard.labels.unknownType' | translate }}
  </ng-template>
</tui-island>
